<template>
  <div class="vue-step-wizard">
    <div class="step-header">
      <div class="step-progress" role="navigation">
        <wizardstepper
          :steps="tabs.filter((s) => s.title).map((a) => a.title)"
          :step="currentTab"
          @click="clickStep"
        />
      </div>
    </div>
    <div class="step-body">
      <b-row>
        <!-- <b-col cols="1">
          <b-card-img
            src="/img/brand/wizard_theme_travel.jpg"
            alt="Image"
            class="rounded-0"
            height="100%;"
          ></b-card-img>
        </b-col> -->
        <b-col cols="12">
          <form>
            <slot></slot>
          </form>
        </b-col>
      </b-row>
    </div>
    <div class="step-footer">
      <div class="btn-group" role="group">
        <template v-if="!submitSuccess">
          <!-- class="step-button step-button-previous" -->
          <b-button
            squared
            size="sm"
            @click="previousTab"
            :disabled="currentTab === 1"
            variant="outline-primary"
            :style="'width:100px;'"
            >Previous</b-button
          >
          <!-- class="step-button step-button-next" -->
          <b-button
            squared
            size="sm"
            @click="nextTab"
            v-if="currentTab < totalTabs - 1"
            variant="primary"
            class="ml-2"
            :style="'width:100px;'"
            >Next</b-button
          >
          <!-- class="step-button step-button-submit" -->
          <b-button
            squared
            size="sm"
            @click="onSubmit"
            v-if="currentTab === totalTabs - 1"
            variant="outline-primary"
            class="ml-2"
            :style="'width:100px;'"
            >Submit</b-button
          >
        </template>
        <template v-else>
          <!-- class="step-button step-button-reset" -->
          <b-button
            squared
            size="sm"
            variant="primary"
            :style="'width:100px;'"
            @click="reset"
          >
            Reset
          </b-button>
        </template>
      </div>
      <!-- {{progress}} -->
    </div>
  </div>
</template>
<script>
import { store } from "./store.js";
import wizardstepper from "./wizard-stepper.vue";

export default {
  name: "wizard-form",
  components: {
    wizardstepper,
  },
  data() {
    return {
      tabs: [],
      currentTab: 0,
      totalTabs: 0,
      storeState: store.state,
      submitSuccess: false,
      progress: 0,
      spacing: 25,
      isValidationSupport: false,
    };
  },
  mounted() {
    this.tabs = this.$children;
    this.totalTabs = this.tabs.length;
    this.currentTab = this.tabs.findIndex((tab) => tab.isActive === true);

    //Select first tab if none is marked selected
    if (this.currentTab === -1 && this.totalTabs > 0) {
      this.tabs[0].isActive = true;
      this.currentTab = 0;
    }

    this.spacing = 100 / this.totalTabs;

    //Setup Initial Progress
    this.progress = (this.currentTab / this.totalTabs) * 100;
  },

  updated() {
    /*
          Using this lifehook - since store variable gets updated after component is mounted
          isValidationSupport checks if user is looking to perform validation on each step
        */
    this.isValidationSupport =
      Object.keys(this.storeState.v).length !== 0 &&
      this.storeState.v.constructor === Object
        ? true
        : false;
  },
  computed: {
    percentdone() {
      let percent = this.currentTab * (100 / this.tabs.length);
      console.log(percent);
      return percent;
    },
  },
  methods: {
    clickStep(step) {
      this._switchTab(step);
    },
    previousTab() {
      this._switchTab(this.currentTab - 1);

      this.$emit("onPreviousStep");
    },
    nextTab() {
      if (this._validateCurrentTab() === false) return;

      this._switchTab(this.currentTab + 1);

      this.$emit("onNextStep");
    },
    reset() {
      this.tabs.forEach((tab) => {
        tab.isActive = false;
        tab.isValidated = false;
      });

      this._switchTab(1);
      this.submitSuccess = false;
      this.storeState.v.$reset();

      this.$emit("onReset");
    },

    changeStatus() {
      this.submitSuccess = true;
    },

    selectTab(index) {
      //Only switch to filled previous tabs
      if (index < this.currentTab) {
        this._switchTab(index);
        return;
      }

      if (this._validateCurrentTab() === false) {
        return;
      }

      if (this.tabs[index - 1].isValidated === false) {
        return;
      }

      this._switchTab(index);
    },

    onSubmit() {
      if (this._validateCurrentTab() === false) return;
      this.$emit("onComplete");
    },

    _switchTab(index) {
      //Disable all tabs
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      this.currentTab = index;
      this.tabs[index].isActive = true;

      this.progress = (this.currentTab / (this.totalTabs - 1)) * 100;
    },

    _validateCurrentTab() {
      if (!this.isValidationSupport)
        //Check if user wants to validate
        return true;

      this.storeState.v.$touch();

      if (this.storeState.v.$invalid) {
        this.tabs[this.currentTab].isValidated = false;
        return false;
      }

      this.tabs[this.currentTab].isValidated = true;

      return true;
    },
  },
  watch: {
    currentTab() {
      store.setCurrentTab(this.currentTab);
    },
  },
};
</script>

<style>
/* .step-header::before { */
  /* margin: 10px; */
  /* background-image: url('/img/brand/progress.jpg'); */
      /* filter: gray; IE6-9 */
  /* -webkit-filter: grayscale(1); Google Chrome, Safari 6+ & Opera 15+ */
  /* filter: grayscale(1); Microsoft Edge and Firefox 35+ */
  /* opacity: .5; */
/* } */

.step-body {
  /* background-color: white; */
  margin-left: auto;
  padding: 1rem;
  /* border-radius: 1rem; */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.step-footer {
  margin-left: auto;
  padding: 1rem;
  /* border-radius: 1rem; */
  margin: 1rem 0rem;
  text-align: center;
}

.tabStatus {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
  line-height: 1.5rem;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.38);
  border-radius: 50%;
}

.modal-content label {
  margin-bottom: 1px;
}
.form-group {
  margin-bottom: 0.2rem;
}

.step-progress {
  display: inline-block;
  /* position: relative; */
  width: 100%;
  height: 100px;
  padding: 1rem;
  /* border: 1px; */
  /* border-radius: 1rem; */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
</style>


